// GLOBAL STATE MANAGER
/*
 *
 */
import i18n from "@/plugins/i18n";

const getDefaultState = function() {
    return {
        // Initial state
        hasSplashed: false, // SplashScreen has been executed
        leftNavDrawer: true, // Left Navigation Drawer is opened (true) or not (false)
        leftTempNavDrawer: true, // Left Temporary Navigation Drawer is opened (true) or not (false)
        globalNotificationsPanel: false, // Global Notification Panel is opened (true) or not (false)
        // rightTempNavDrawer: true, // TODO: NOT USED FOR NOW
        globalControls: {
            toast: {
                activator: false,
                type: "",
                message: "",
            },
            loader: {
                activator: false,
                message: "",
            },
        },
        settings:{
            buttons: true,
            notificationsType: {
                previous: {
                    value:0,
                    description:""
                },
                current: {
                    value:0,
                    description:""
                },
            },
            notificationsCountry: null,
            notificationsIndustry: null,
            notificationsTech: null,
            notificationsOpco: null,
        },
        navigationData: {
            previousPath:  "",
            currentPageData: {}
        },
        availableChatbotEngines: [
            {
                name: "IBM Watson",
                image: require("@/assets/img/chatbot/engine/ibm-watson.png"),
            },
            {
                name: "Dialog Flow",
                image: require("@/assets/img/chatbot/engine/google-dialogflow.png"),
            },
            {
                name: "Microsoft LUIS",
                image: require("@/assets/img/chatbot/engine/microsoft-luis.png"),
            },
            {
                name: "Amazon Lex",
                image: require("@/assets/img/chatbot/engine/amazon-lex.png"),
            },
        ],
        availableNotificationsType:[
            {
                name:"On startup registration",
                value:0,
                icon: 'mdi-mail',
                color:'black'
            },
            {
                name:"Weekly report",
                value:1,
                icon: 'mdi-calendar-check',
                color:'black'

            },

        ],
        availableLocales: [
            {
                name: "English",
                locale: "en",
                image: require("@/assets/img/settings/flags/en.png"),
            },
            {
                name: "Italiano",
                locale: "it",
                image: require("@/assets/img/settings/flags/it.png"),
            },
            {
                name: "Espanol",
                locale: "es",
                image: require("@/assets/img/settings/flags/es.png"),
            },
            {
                name: "Automatic",
                locale: "auto",
                image: require("@/assets/img/settings/flags/auto.png"),
            },
        ],
    };
};

const state = getDefaultState();


const getters = {
    hasSplashed: (state) => {
        return state.hasSplashed;
    },
    isLeftNavDrawer: (state) => {
        return state.leftNavDrawer;
    },
    isLeftTempNavDrawer: (state) => {
        return state.leftTempNavDrawer;
    },
    isGlobalNotificationsPanel: (state) => {
        return state.globalNotificationsPanel;
    },
    getNavigationData: (state) => {
        return state.navigationData;
    },
    getAvailableLocales: (state) => {
        return state.availableLocales;
    },
    getAvailableNotificationsType: (state) => {
        return state.availableNotificationsType;
    },
    getAvailableChatbotEngines: (state) => {
        return state.availableChatbotEngines;
    },
    getGlobalToastState: (state) => {
        return state.globalControls.toast;
    },
    getGlobalLoaderState: (state) => {
        return state.globalControls.loader;
    },
    getSettings: (state) => {
        return state.settings;
    },
};

const actions = {
    resetState ({ commit }) {
        commit("resetState");
    },
    setHasSplashed({commit}, hasSplashed) {
        commit("setHasSplashed", hasSplashed);
    },
    setLeftNavDrawer({commit}, leftNavDrawer) {
        commit("setLeftNavDrawer", leftNavDrawer);
    },
    setLeftTempNavDrawer({commit}, leftTempNavDrawer) {
        commit("setLeftTempNavDrawer", leftTempNavDrawer);
    },
    setNavigationData({commit}, navigationDataState) {
        commit("setNavigationData", navigationDataState);
    },
    setGlobalNotificationsPanel({commit,}, globalNotificationsPanel) {
        commit("setGlobalNotificationsPanel", globalNotificationsPanel);
    },
    setRightTempNavDrawer({commit,}, rightTempNavDrawer) {
        commit("setRightTempNavDrawer", rightTempNavDrawer);
    },
    setAppNavDrawerElementsAdmin({commit,}, appNavDrawerElementsAdminState) {
        commit("setAppNavDrawerElementsAdmin", appNavDrawerElementsAdminState);
    },
    setGlobalToastState({commit,}, globalToastState) {
        commit("setGlobalToastState", globalToastState);
    },
    setGlobalLoaderState({commit,}, globalLoaderState) {
        commit("setGlobalLoaderState", globalLoaderState);
    },
    setSettings({commit,}, settings) {
        commit("setSettings", settings);
    },
};

const mutations = {
    resetState (state) {
        Object.assign(state, getDefaultState());
    },
    setHasSplashed(state, hasSplashed) {
        state.hasSplashed = hasSplashed;
        // console.log('AppState -> setHasSplashed: ' + state.hasSplashed);
    },
    setLeftNavDrawer(state, leftNavDrawer) {
        state.leftNavDrawer = leftNavDrawer;
        // console.log('AppState -> setLeftTempNavDrawer: ' + state.leftNavDrawer);
    },
    setLeftNavDrawerMini(state, isLeftNavDrawerMini) {
        state.isLeftNavDrawerMini = isLeftNavDrawerMini;
        //console.log("AppState -> setLeftNavDrawerMini: ", state.isLeftNavDrawerMini);
    },
    setLeftTempNavDrawer(state, leftTempNavDrawer) {
        state.leftTempNavDrawer = leftTempNavDrawer;
        // console.log('AppState -> setLeftTempNavDrawer: ' + state.leftTempNavDrawer);
    },
    setNavigationData(state, navigationDataState) {
        state.navigationData = navigationDataState;
        //console.log('AppState -> setNavigationData: ', state.navigationData);
    },
    setGlobalNotificationsPanel(state, globalNotificationsPanel) {
        state.globalNotificationsPanel = globalNotificationsPanel;
        //console.log('AppState -> setGlobalNotificationsPanel: ', state.globalNotificationsPanel);
    },
    setRightTempNavDrawer(state, rightTempNavDrawer) {
        state.rightTempNavDrawer = rightTempNavDrawer;
        // console.log('AppState -> setRightTempNavDrawer: ', state.rightTempNavDrawer);
    },
    setAppNavDrawerElementsAdmin(state, appNavDrawerElementsAdminState) {
        state.appNavDrawerElementsAdmin = appNavDrawerElementsAdminState;
        // console.log('AppState -> setAppNavDrawerElementsAdmin: ', state.appNavDrawerElementsAdmin);
    },
    setGlobalToastState(state, globalToastState) {
        state.globalControls.toast = globalToastState;
        //console.log('AppState -> setGlobalToastState: ', state.globalControls.toast);
    },
    setGlobalLoaderState(state, globalLoaderState) {
        state.globalControls.loader = globalLoaderState;
        //console.log('AppState -> setGlobalLoaderState: ', state.globalControls.loader);
    },
    setSettings(state, settings) {
        state.settings = settings;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
